<mat-toolbar color="primary" class="app-header">

    <div> Bienestar</div>

    <img src="assets/img/logo_junji.jpg" height=150px width=200px>

    <!--<span class = "nav-tool-items" style = "margin-left:80%">

        <a mat-button routerLink="login" routerLinkActive = "active">Log in</a>

        <a mat-button mat-raised-button routerLink = "register" routerLinkActive = "active"> Register </a>

    </span>-->

</mat-toolbar>
<nav *ngIf="this.muestraMenu">
    
    <a id="resp-menu" class="responsive-menu" href="#"> <i class="fa fa-bars"> </i> Menu </a>

    <ul class="menu">
   
    <li *ngIf="this.jubilado!='true' &&(isEncargadoNacional || isFuncionario || isEjecutivo || isEjecutivoCaip || isAdmin || isAsistenteSocial || isContabilidad || isCoordinador || isEncargadoContabilidad || isEncargadoRegional || isEncargadoRegionalContable)"> 
            <a class="homer" routerLink="/index"><i class = "fa fa-home"></i> INICIO </a>
    </li>
    <li *ngIf="this.jubilado=='true' && (isEncargadoNacional || isFuncionario || isEjecutivo || isEjecutivoCaip || isAdmin || isAsistenteSocial || isContabilidad || isCoordinador || isEncargadoContabilidad || isEncargadoRegional || isEncargadoRegionalContable)"> 
        <a class="homer" routerLink="/index-jub"><i class = "fa fa-home"></i> INICIO </a>
    </li>
        <li *ngIf="isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isAsistenteSocial || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isContabilidad || isEncargadoContabilidad">

            <a> <i class="fa fa-envelope"> </i> SUBSIDIOS </a>

            <ul class="sub-menu">

                <li *ngIf="isEncargadoNacional || isFuncionario || isEjecutivoCaip || isAdmin || isAsistenteSocial || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador || isContabilidad || isEncargadoContabilidad">

                    <a> <i class="fa fa-list"> </i> BECAS </a>

                    <ul>
                        <li>
                            <a *ngIf="this.jubilado!='true' && (isEncargadoNacional || isFuncionario || isAdmin ||  isAsistenteSocial || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador || isContabilidad || isEncargadoContabilidad)" routerLink="/becas/">
                                <i class="fa fa-desktop"> </i> SOLICITAR </a>
                            
                            <a *ngIf="this.jubilado=='true' && (isEncargadoNacional || isFuncionario || isAdmin ||  isAsistenteSocial || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador || isContabilidad || isEncargadoContabilidad)" routerLink="/becas-jub/">
                                <i class="fa fa-desktop"> </i> SOLICITAR </a>
                        </li>

                        <li>
                            <a *ngIf="isAsistenteSocial || isAdmin || isCoordinador" routerLink="/ranking/"> <i class="fa fa-star"> </i> RANKING </a>
                        </li>
                    </ul>

                </li>

                <li *ngIf="this.jubilado!='true' && (isEjecutivo ||  isFuncionario || isEjecutivoCaip || isAdmin || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador || isAsistenteSocial || isContabilidad || isEncargadoNacional || isEncargadoContabilidad)">
                    <a routerLink="/escolaridad/"> <i class="fa fa-graduation-cap"> </i> ESCOLARIDAD </a>
                </li>
                <li *ngIf="this.jubilado=='true' && (isEjecutivo ||  isFuncionario || isEjecutivoCaip || isAdmin || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador || isAsistenteSocial || isContabilidad || isEncargadoNacional || isEncargadoContabilidad)">
                    <a routerLink="/escolaridad-jub/"> <i class="fa fa-graduation-cap"> </i> ESCOLARIDAD </a>
                </li>
                                	
                
                <li *ngIf="this.jubilado!='true' && (isEncargadoNacional || isEjecutivo || isFuncionario || isAdmin  || isEjecutivoCaip || isContabilidad || isEncargadoContabilidad || isAsistenteSocial || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador)">
                    <a routerLink="/nacimiento/"> <i class="fa fa-baby"> </i> NACIMIENTO </a>
                </li>
                <li *ngIf="this.jubilado=='true' && (isEncargadoNacional || isEjecutivo || isFuncionario || isAdmin  || isEjecutivoCaip || isContabilidad || isEncargadoContabilidad || isAsistenteSocial || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador)">
                    <a routerLink="/nacimiento-jub/"> <i class="fa fa-baby"> </i> NACIMIENTO </a>
                </li>
                
            
                <li *ngIf="this.jubilado!='true' && (isEncargadoNacional || isEjecutivo || isFuncionario || isAdmin  || isEjecutivoCaip|| isContabilidad || isEncargadoContabilidad || isAsistenteSocial || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador)">
                    <a routerLink="/matrimonio/"> <i class="fa fa-church"> </i> MATRIMONIO </a>
                </li>
                <li *ngIf="this.jubilado=='true' && (isEncargadoNacional || isEjecutivo || isFuncionario || isAdmin  || isEjecutivoCaip|| isContabilidad || isEncargadoContabilidad || isAsistenteSocial || isEncargadoRegional  || isEncargadoRegionalContable || isCoordinador)">
                    <a routerLink="/matrimonio-jub/"> <i class="fa fa-church"> </i> MATRIMONIO </a>
                </li>

                <li *ngIf="this.jubilado!='true' && (isEncargadoNacional ||  isEjecutivo || isFuncionario || isAdmin || isContabilidad  || isEjecutivoCaip || isEncargadoContabilidad || isAsistenteSocial || isEncargadoRegional  || isEncargadoRegionalContable || isCoordinador)">
                    <a routerLink="/catastrofe/"> <i class="fa fa-window-close"> </i> CATÁSTROFE </a>
                </li>
                <li *ngIf="this.jubilado=='true' && (isEncargadoNacional ||  isEjecutivo || isFuncionario || isAdmin || isContabilidad  || isEjecutivoCaip || isEncargadoContabilidad || isAsistenteSocial || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador)">
                    <a routerLink="/catastrofe-jub/"> <i class="fa fa-window-close"> </i> CATÁSTROFE </a>
                </li>

                <li *ngIf="this.jubilado!='true' && (isEncargadoNacional  || isEjecutivo || isFuncionario || isAdmin || isContabilidad  || isEjecutivoCaip || isEncargadoContabilidad || isAsistenteSocial || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador)">
                    <a routerLink="/fallecimiento/"> <i class="fa fa-book-dead"> </i> FALLECIMIENTO </a>
                </li>
                <li *ngIf="this.jubilado=='true' && (isEncargadoNacional  || isEjecutivo || isFuncionario || isAdmin || isContabilidad  || isEjecutivoCaip || isEncargadoContabilidad || isAsistenteSocial || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador)">
                    <a routerLink="/fallecimiento-jub/"> <i class="fa fa-book-dead"> </i> FALLECIMIENTO </a>
                </li>
             
                <li *ngIf="this.jubilado!='true' && (isEncargadoNacional || isEjecutivo ||  isEjecutivoCaip || isFuncionario || isAdmin || isAsistenteSocial || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/postulaciones/"> <i class="fa fa-copy"> </i> SOLICITUDES </a>
                </li>
                <li *ngIf="this.jubilado=='true' && (isEncargadoNacional || isEjecutivo ||  isEjecutivoCaip || isFuncionario || isAdmin || isAsistenteSocial || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/postulaciones-jub/"> <i class="fa fa-copy"> </i> SOLICITUDES </a>
                </li>
            </ul>

        </li>
        <li *ngIf="isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad">
            <a> <i class="fa fa-heart"> </i> SALUD </a>

            <ul class="sub-menu">
                <li *ngIf="this.jubilado!='true' && (isEncargadoNacional || isAsistenteSocial ||isEjecutivo  || isCoordinador || isFuncionario || isAdmin || isEncargadoRegional || isEncargadoRegionalContable || isEjecutivoCaip || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/reembolsos/"> <i class="fa fa-retweet"> </i> REEMBOLSO </a>
                </li>

                <li *ngIf="this.jubilado=='true' && (isEncargadoNacional || isAsistenteSocial ||isEjecutivo  || isCoordinador || isFuncionario || isAdmin || isEncargadoRegional || isEncargadoRegionalContable || isEjecutivoCaip || isContabilidad || isEncargadoContabilidad) ">
                    <a routerLink="/reembolsos-jub/"> <i class="fa fa-retweet"> </i> REEMBOLSO </a>
                </li>
              
                <li *ngIf="this.jubilado!='true' && (isEncargadoNacional || isAsistenteSocial ||isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador)">
                    <a routerLink="/ayuda-medica/"> <i class="fa fa-briefcase-medical"> </i> AYUDA MÉDICA </a>
                </li>
                <li *ngIf="this.jubilado=='true' && (isEncargadoNacional || isAsistenteSocial ||isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isEncargadoRegional || isEncargadoRegionalContable || isCoordinador)">
                    <a routerLink="/ayuda-medica-jub/"> <i class="fa fa-briefcase-medical"> </i> AYUDA MÉDICA </a>
                </li>
              
                <li *ngIf="this.jubilado!='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isAsistenteSocial || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/postulaciones-salud/"> <i class="fa fa-copy"> </i> SOLICITUDES </a>
                </li>
                <li *ngIf="this.jubilado=='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isAsistenteSocial || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/postulaciones-salud-jub/"> <i class="fa fa-copy"> </i> SOLICITUDES </a>
                </li>
           
            </ul>

        </li>
        <li *ngIf="isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad">
            <a> <i class="fa fa-hand-holding-usd"> </i> PRESTAMOS </a>

            <ul class="sub-menu">
                
                <li *ngIf="this.jubilado!='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/prestamos/"> <i class="fa fa-retweet"> </i> SOLICITAR </a>
                </li>
                <li *ngIf="this.jubilado=='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/prestamos-jub/"> <i class="fa fa-retweet"> </i> SOLICITAR </a>
                </li>

                <li *ngIf="this.jubilado!='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">               
                    <a routerLink="/consulta-prestamos/"> <i class="fa fa-copy"> </i> SOLICITUDES </a>
                </li>
                <li *ngIf="this.jubilado=='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">               
                    <a routerLink="/consulta-prestamos-jub/"> <i class="fa fa-copy"> </i> SOLICITUDES </a>
                </li>

                <li *ngIf="this.jubilado !='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">
                       <a routerLink="/prestamo-abono/"> <i class="fa fa-money-check-alt"> </i> PAGOS </a>
                </li>
                <li *ngIf="this.jubilado=='true' &&  (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/prestamo-abono-jub/"> <i class="fa fa-money-check-alt"> </i> PAGOS </a>
             </li>
                <!--  <li *ngIf="isContabilidad || isEncargadoContabilidad || isAdmin"> -->
                <li *ngIf="isEncargadoNacional || isEjecutivo || isEjecutivoCaip ||  isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad">    

                    <a routerLink="/consulta-pagos-prestamos/"> <i class="fa fa-money-bill"> </i> PAGOS A VALIDAR </a>

                </li>

            </ul>

        </li>

        <li *ngIf="isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegionalContable || isEncargadoRegional || isAsistenteSocial || isContabilidad || isEncargadoContabilidad">
            <a> <i class="fa fa-handshake"></i> CONVENIOS </a>

            <ul class="sub-menu">
                <li *ngIf="this.jubilado !='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">
                  <a routerLink="/convenio/"> <i class="fa fa-retweet"> </i> SOLICITAR </a>
                </li>
                <li *ngIf="this.jubilado =='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/convenio-jub/"> <i class="fa fa-retweet"> </i> SOLICITAR </a>
                  </li>
            
                <li *ngIf="this.jubilado !='true' && (!isEjecutivoCaip)">
                    <a routerLink="/convenio-colaboracion/"> <i class="fa fa-retweet"> </i>SOLICITAR COLABORACIÓN</a>
                </li>
                <li *ngIf="this.jubilado =='true' && (!isEjecutivoCaip)">
                    <a routerLink="/convenio-colaboracion/"> <i class="fa fa-retweet"> </i>SOLICITAR COLABORACIÓN.</a>
                </li>


                <li *ngIf="this.jubilado !='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/consulta-convenio/"> <i class="fa fa-copy"> </i> SOLICITUDES </a>
                </li>
                <li *ngIf="this.jubilado =='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/consulta-convenio-jub/"> <i class="fa fa-copy"> </i> SOLICITUDES </a>
                </li>

                <li *ngIf="this.jubilado !='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/convenio-abono/"> <i class="fa fa-money-check-alt"> </i> PAGOS </a>
                </li>
                <li *ngIf="this.jubilado =='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad)">
                    <a routerLink="/convenio-abono-jub/"> <i class="fa fa-money-check-alt"> </i> PAGOS </a>
                </li>
                <li *ngIf="isEncargadoNacional || isEjecutivo || isEjecutivoCaip ||  isAdmin || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isAsistenteSocial || isContabilidad || isEncargadoContabilidad">    
                    <a routerLink="/consulta-pagos-convenio/"> <i class="fa fa-money-bill"> </i> PAGOS A VALIDAR </a>
                </li>

                <li *ngIf="isContabilidad || isEncargadoContabilidad || isAdmin">

                    <a routerLink="/carga-convenios/"> <i class="fa fa-copy"> </i> CARGA CONVENIOS</a>

                </li>

                <li *ngIf="isContabilidad || isEncargadoContabilidad || isAdmin">

                    <a routerLink="/carga-abonos/"> <i class="fa fa-copy"> </i> CARGA ABONOS </a>

                </li>

                <li *ngIf="isContabilidad || isEncargadoContabilidad || isAdmin">

                    <a routerLink="/carga-descuentos/"> <i class="fa fa-copy"> </i> CARGA DESCUENTOS </a>

                </li>

            </ul>

        </li>
        <li *ngIf="isContabilidad || isEncargadoContabilidad || isAdmin || isCoordinador">
            <a> <i class="fa fa-dollar-sign"> </i> PAGOS </a>

            <ul class="sub-menu">

                <li *ngIf="isContabilidad || isEncargadoContabilidad || isAdmin  || isCoordinador">

                    <a routerLink="/pagos/"> <i class="fa fa-money-bill"> </i> SOLICITUDES A PAGAR </a>

                </li>

                <li *ngIf="isContabilidad || isEncargadoContabilidad || isAdmin  || isCoordinador">

                    <a routerLink="/grupos-pago/"> <i class="fa fa-copy"> </i> GRUPOS DE PAGO </a>

                </li>

            </ul>

        </li>

        <li *ngIf="isAdmin || isEjecutivoCaip || isEncargadoNacional || isCoordinador || isEjecutivo || isAsistenteSocial  || isEncargadoContabilidad || isContabilidad || isEncargadoRegional || isEncargadoRegionalContable">
            <a> <i class="fa fa-list"> </i> MANTENEDORES </a>

            <ul class="sub-menu">

                <li *ngIf="isAdmin">

                    <a routerLink="/mantenedor-usuarios/"> <i class="fa fa-user"> </i> USUARIOS </a>
                </li>
                <li *ngIf="isAdmin || isEjecutivoCaip || isCoordinador || isEncargadoNacional || isEjecutivo || isAsistenteSocial  || isEncargadoContabilidad || isContabilidad || isEncargadoRegional || isEncargadoRegionalContable">

                    <a routerLink="/mantenedor-cargas/"> <i class="fa fa-user"> </i> CARGAS FAMILIARES </a>
                </li>

                <li *ngIf="isAdmin ||  isCoordinador || isEncargadoContabilidad || isContabilidad">

                    <a routerLink="/mantenedor-proveedor/"> <i class="fa fa-user"> </i> PROVEEDORES </a>
                </li>

                <li *ngIf="isAdmin ||  isCoordinador || isEncargadoContabilidad || isContabilidad">

                    <a routerLink="/mantenedor-convenio-colaboracion/"> <i class="fa fa-user"> </i> CONVENIO COLABORACIÓN </a>
                </li>

                <li *ngIf="!isFuncionario">

                    <a routerLink="/mantenedor-codeudores/"> <i class="fa fa-user"> </i> CODEUDORES </a>
                </li>
                
                <!--<li *ngIf = "isAdmin">

                    <a routerLink = "/mantenedor-cargas/"> <i class = "fa fa-user"> </i> CARGAS </a>

                </li>-->

                <li *ngIf="isAdmin">

                    <a routerLink="/cargas-masivas/"> <i class="fa fa-download"> </i> CARGAS MASIVAS </a>

                </li>

            </ul>

        </li>
      
          
        <li *ngIf="isAdmin || isEjecutivo || isAsistenteSocial || isContabilidad || isEncargadoContabilidad
        || isCoordinador || isEncargadoRegional || isEncargadoRegionalContable || isEjecutivoCaip || isEncargadoNacional">
            <a> <i class="fas fa-address-card"> </i> AFILIACION </a>      
            <ul class="sub-menu">
                <li>
                    <a routerLink="/afiliacion/"> <i class="fas fa-address-card"> </i> AFILIACION </a>
                </li>   
                
                <li *ngIf="isAdmin || isContabilidad">
                    <a routerLink="/solicitudes-afiliacion/"> <i class="fa fa-copy"> </i> SOLICITUDES DE AFILIACIÓN </a>
                </li>
               
                <li *ngIf="isAdmin || isContabilidad">
                    <a routerLink="/listado-pendientes/"> <i class="fa fa-copy"> </i> LISTADO PENDIENTES </a>
                </li>

                <li *ngIf="isAdmin || isContabilidad">
                    <a routerLink="/carga-cuotas/"> <i class="fa fa-copy"> </i> CARGA CUOTAS</a>
                </li>

                <li>
                    <a routerLink="/cuotas-pagadas/"> <i class="fa fa-copy"> </i>HISTORIAL CUOTAS PAGADAS </a>
                </li>

                <li *ngIf="isAdmin || isContabilidad  || isEncargadoRegionalContable">
                    <a routerLink="/consulta-pagos-afiliado/"> <i class="fa fa-copy"> </i>CONSULTA PAGOS</a>
                </li>

            </ul>

        </li>
       
        <li *ngIf="isFuncionario">
            <a> <i class="fas fa-address-card"> </i> MIS DATOS </a>      
            <ul class="sub-menu">              
                <li *ngIf="this.jubilado!='true' && (isFuncionario)">
                    <a routerLink="/afiliacion/"> <i class="fas fa-address-card"> </i> MIS DATOS </a>
                </li>  
                <li *ngIf="this.jubilado=='true' && (isFuncionario)">
                    <a routerLink="/afiliacion/"> <i class="fas fa-address-card"> </i> MIS DATOS </a>
                </li>
                <li>
                    <a routerLink="/cuotas-pagadas/"> <i class="fa fa-copy"> </i>HISTORIAL CUOTAS PAGADAS </a>
                </li>               
            </ul>

        </li>
  
        <li *ngIf="this.jubilado!='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isAsistenteSocial || isContabilidad || isCoordinador || isEncargadoContabilidad || isEncargadoRegional || isEncargadoRegionalContable || isAnonymus)">
            <a (click)="logout()" routerLink="/login"> <i class="fa fa-user"> </i> LOGOUT </a>     
        </li>
        <li *ngIf="this.jubilado=='true' && (isEncargadoNacional || isEjecutivo || isEjecutivoCaip || isFuncionario || isAdmin || isAsistenteSocial || isContabilidad || isCoordinador || isEncargadoContabilidad || isEncargadoRegional || isEncargadoRegionalContable || isAnonymus)">
            <a (click)="logoutJubilado()" routerLink="/login"> <i class="fa fa-user"> </i> LOGOUT </a>     
        </li>
       

        <li *ngIf="!isEncargadoNacional && !isEjecutivo && !isEjecutivoCaip && !isFuncionario && !isAdmin && !isAsistenteSocial && !isContabilidad && !isCoordinador && !isEncargadoContabilidad && !isEncargadoRegional && !isEncargadoRegionalContable && !isAnonymus ">

            <a routerLink="/login"> <i class="fa fa-user"> </i> LOGIN </a>

        </li>

    </ul>

</nav>

<router-outlet> </router-outlet>

<!-- Footer -->
<footer class="page-footer font-small" style="background-color: #0f69b4">

    <!-- Copyright -->
    <div class="footer-copyright text-center py-3" style="height: 100px; color:white">© 2025 Copyright - V.20250708</div>
    <!-- Copyright -->

</footer>
<!-- Footer -->